/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const chip = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#chip_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M5.5 1v1.5m5-1.5v1.5M5.5 15v-1.5m5 1.5v-1.5m4.5-3h-1.5m1.5-5h-1.5M1 10.5h1.5M1 5.5h1.5m0 0v-2a1 1 0 0 1 1-1h2m-3 3v5m0 0v2a1 1 0 0 0 1 1h2m0 0h5m0 0h2a1 1 0 0 0 1-1v-2m0 0v-5m0 0v-2a1 1 0 0 0-1-1h-2m0 0h-5m.61 2.75h3.78c.473 0 .86.387.86.86v3.78c0 .473-.387.86-.86.86H6.11a.862.862 0 0 1-.86-.86V6.11c0-.473.387-.86.86-.86Z"
      />
    </g>
    <defs>
      <clipPath id="chip_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default chip
